export const requiredHeaders = ['Authorization'];
export const RESOURCES = {
  actions: 'actions',
  'draft-actions': 'draft-actions',
  territories: 'territories',
  priorizaciones: 'priorizaciones',
  disclaimers: 'disclaimers',
  studies: 'studies',
  etapas: 'etapas',
  types: 'types',
  scopes: 'scopes',
  terms: 'terms',
  sources: 'sources',
  'financiadores-estudios': 'financiadores-estudios',
  themes: 'themes',
  subthemes: 'subthemes',
  'chart-categories': 'chart-categories',
  'subtheme-categories': 'subtheme-categories',
  paises: 'countries',
  metrics: 'metrics',
  'metric-values': 'metric-values',
  countries: 'countries',
  layers: 'layers',
};

export const defaultListProps = { bulkActionButtons: false };
